import { Box, Stack } from '@mui/material';
import { DEFAULT_MARGIN_NORMAL } from '@portals/core/src/components/Spacer/Spacer';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import { slugify } from '@portals/core/src/utilities/slugify';
import React, { ReactElement } from 'react';

import { ContentIntro as ContentIntroModel } from '../../../models';
import { Consumer } from '../../consumers/Consumer/Consumer';
import { useLinkProps } from '../../hooks/useLinkProps';

export interface Props {
  node: ContentIntroModel;
  children?: ReactElement | ReactElement[];
}

export const ContentIntro: React.FunctionComponent<Props> = ({ node, children }: Props) => {
  const { singleProps } = useLinkProps(node.link && node.link[0]);

  return (
    <Stack rowGap={DEFAULT_MARGIN_NORMAL}>
      {node.text || node.link?.length ? (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          data-selector={`${node.__component}.${node.id}.headline`}
          columnGap={6}
          rowGap={5}
        >
          {node.text ? (
            <Typography
              component={node.component}
              variant="h3"
              innerPadding="horizontal"
              display="flex"
              alignItems="center"
              id={slugify(node.text)}
              data-selector={`${node.__component}.${node.id}.text`}
            >
              {node.textIcon?.icon ? (
                <>
                  <Consumer node={node.textIcon} />
                  <Box mx={4} />
                </>
              ) : null}
              {node.text}
            </Typography>
          ) : null}

          {node.link && node.link.length ? (
            <Typography
              component="div"
              variant="button"
              marginLeft="auto"
              display="flex"
              alignItems="center"
              fontWeight="bold"
              data-selector={`${node.__component}.${node.id}.link`}
              {...singleProps}
            >
              {node.link[0].text}
              {node.linkIcon ? (
                <>
                  <Box mx={{ xs: 2, lg: 4 }} />
                  <Consumer node={node.linkIcon} />
                </>
              ) : null}
            </Typography>
          ) : null}
        </Stack>
      ) : null}
      <Box>{children}</Box>
    </Stack>
  );
};
